export default {
  init() {
    this.initHandlers();
  },

  initHandlers() {
    // Handle permanent delete modal for single work
    $('#permanentDeletePopup').on('show.bs.modal', function (event) {
      const button = $(event.relatedTarget);
      const modal = $(this);
      modal.find('[data-delete="true"]').attr('href', button.attr('data-href'));
    });

    // Handle bulk delete functionality
    const selectAllCheckbox = document.getElementById('selectAll');
    const workCheckboxes = document.querySelectorAll('.work-checkbox');
    const bulkDeleteBtn = document.getElementById('bulkDeleteBtn');
    const confirmBulkDeleteBtn = document.getElementById('confirmBulkDelete');

    // Handle "Select All" checkbox
    if (selectAllCheckbox) {
      selectAllCheckbox.addEventListener('change', function () {
        workCheckboxes.forEach(checkbox => {
          checkbox.checked = this.checked;
        });
        updateBulkDeleteButton();
      });
    }

    // Handle individual checkboxes
    workCheckboxes.forEach(checkbox => {
      checkbox.addEventListener('change', function () {
        updateBulkDeleteButton();
        updateSelectAllCheckbox();
      });
    });

    function updateBulkDeleteButton() {
      const checkedBoxes = document.querySelectorAll('.work-checkbox:checked');

      if (bulkDeleteBtn) {
        bulkDeleteBtn.disabled = checkedBoxes.length === 0;
      }
    }

    function updateSelectAllCheckbox() {
      if (selectAllCheckbox) {
        const allChecked = Array.from(workCheckboxes).every(cb => cb.checked);
        const someChecked = Array.from(workCheckboxes).some(cb => cb.checked);
        selectAllCheckbox.checked = allChecked;
        selectAllCheckbox.indeterminate = someChecked && !allChecked;
      }
    }

    // Handle bulk delete confirmation
    if (confirmBulkDeleteBtn) {
      confirmBulkDeleteBtn.addEventListener('click', function () {
        const checkedBoxes = document.querySelectorAll('.work-checkbox:checked');
        const ids = Array.from(checkedBoxes).map(cb => cb.value);

        if (ids.length === 0) {
          return;
        }

        // Get the bulk delete URL from the page
        const bulkDeleteUrl = confirmBulkDeleteBtn.getAttribute('data-bulk-delete-url');

        if (!bulkDeleteUrl) {
          console.error('Bulk delete URL not found');
          return;
        }

        // Create form and submit
        const form = document.createElement('form');
        form.method = 'POST';
        form.action = bulkDeleteUrl;

        ids.forEach(id => {
          const input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'ids[]';
          input.value = id;
          form.appendChild(input);
        });

        document.body.appendChild(form);
        form.submit();
      });
    }
  },
};
